import { createIcon } from '../createIcon';

export const BoxesIconConfig = {
  name: 'BoxesIcon',
  height: 512,
  width: 576,
  svgPath: "M560 288h-80v96l-32-21.3-32 21.3v-96h-80c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16zm-384-64h224c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16h-80v96l-32-21.3L256 96V0h-80c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16zm64 64h-80v96l-32-21.3L96 384v-96H16c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16z",
  yOffset: 0,
  xOffset: 0,
  svgClassName: undefined,
};

export const BoxesIcon = createIcon(BoxesIconConfig);

export default BoxesIcon;